const getTemplateVisualizationsOptions = (visualizations = []) => {
  return visualizations.map((item) => {
    return {
      label: item.title,
      value: item.id,
    };
  });
};

export default getTemplateVisualizationsOptions;
